import { PRIVATEPATHS } from '@core/enums/paths.enum';
import { clearBatchDetail, getBatchByIdThunk } from '@redux/features/batch.slice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import React, { FC, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import BatchDetailContent from './BatchDetailContent';

const BatchDetail: FC = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useAppDispatch();
    const { batchDetail, detailLoading } = useAppSelector((state: RootState) => state.batchState);

    useEffect(() => {
        const batchId = Number(id);
        if (!Number.isFinite(batchId)) return;
        dispatch(getBatchByIdThunk(batchId));
        return () => {
            dispatch(clearBatchDetail());
        };
    }, [id, dispatch]);

    const title = batchDetail?.lotNumber
        ? `Batch — ${batchDetail.lotNumber}${batchDetail.id != null ? ` (#${batchDetail.id})` : ''}`
        : 'Batch detail';

    return (
        <>
            <BreadCrumb pageTitle={title} />
            <section className="py-5">
                <div className="flex flex-col gap-4 bg-white p-4">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                        <Link
                            to={PRIVATEPATHS.Batch}
                            className="text-sm font-medium text-[#bd902e] hover:underline"
                        >
                            ← Back to batch list
                        </Link>
                        <ButtonBase
                            innerText="Refresh"
                            className="!bg-slate-200 !text-slate-800"
                            onClick={() => {
                                const batchId = Number(id);
                                if (Number.isFinite(batchId)) {
                                    dispatch(getBatchByIdThunk(batchId));
                                }
                            }}
                        />
                    </div>
                    <BatchDetailContent batch={batchDetail} loading={detailLoading} showInventory />
                </div>
            </section>
        </>
    );
};

export default BatchDetail;
